import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Checkbox from "../../Components/checkbox/Checkbox";
import ApiDropdown from "../../Components/DropDown/Apidropdown";
import Input from "../../Components/input/input";
import config from "../../config";
import "../../Style/IncidentAdd.css";
import { useFetchFullName } from "./Hooks/useFetchFullName";
import { Incident, initialIncident } from "./Incident";
import TextArea from "../../Components/TextArea/TextArea";
import TaskGridLookup, {
  toRelatedItems,
} from "../../Components/Lookup/IncidentLookUp";import { ChangeData } from "../../utils/Change/changeTypes";
import { KnowledgeBaseData } from "../../utils/KnowledgeBase/KnowledgeBaseTypes";
import { RmaData } from "../../utils/Rma/rmaTypes";
import { TaskData } from "../../utils/Task/taskTypes";
import { ProblemData } from "../../utils/Problem/problemTypes";
import { IncidentData } from "../../utils/Incident/incidentTypes";
import FileUploader from "../../Components/FileUpload/FileUpload";
import { authFetch } from "../../utils/Security/authFetch";
import { handleEdit } from "../../utils/Incident/incidentHandlers";
import Button from "../../Components/button/button";
type Message = {
  id: number;
  username: string;
  message: string;
  date: string;
};
function IncidentEdit() {
  const [emails, setEmails] = useState<[]>();
  const [network, setNetwork] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [site, setSite] = useState<
    string | number | (string | number)[] | null
  >(null);
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const [journalMessages, setJournalMessages] = useState<Message[]>([]);

  const [isTaskLookupOpen, setIsTaskLookupOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState<
    (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  >([]);
  const [customer, setCustomer] = useState<
    string | number | (string | number)[] | undefined
  >(undefined);
  const [incident, setIncident] = useState<Incident>(initialIncident);
  const [originalIncident, setOriginalIncident] =
    useState<Incident>(initialIncident); // Keep track of original data

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const organization = localStorage.getItem("organization") || undefined;
  const isallsite = localStorage.getItem("isAllSite");
  const isallnetwork = localStorage.getItem("isAllNetwork");
  const isalllink = localStorage.getItem("isAllLink");
    const isForTelebras = localStorage.getItem("isForTelebras") === "true";
  const isForPetrobras = localStorage.getItem("isForPetrobras") === "true";
  const isForNilesat = localStorage.getItem("isForNilesat") === "true";

  const handleTaskSelect = (
    tasks: (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  ) => {
    const ticketIds = tasks.map((t) => t.ticketId);
    handleDataChange("relatedobject", ticketIds);
    setSelectedTask(tasks);
  };

  function formatDateTimeLocal(datetime: string): string {
    const date = new Date(datetime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const handleOpenTaskLookup = () => setIsTaskLookupOpen(true);
  const handleCloseTaskLookup = () => setIsTaskLookupOpen(false);

  const mockLoadTasksByIds = async (
    ids: string[]
  ): Promise<
    (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  > => {
    return ids.map((id) => {
      const baseData = {
        ticketId: id,
        title: `Loaded ${id}`,
      };
      if (id.startsWith("TSK")) {
        return { ...baseData, source: "task" } as unknown as TaskData;
      } else if (id.startsWith("CHN")) {
        return { ...baseData, source: "change" } as unknown as ChangeData;
      } else if (id.startsWith("RMA")) {
        return { ...baseData, source: "rma" } as unknown as RmaData;
      } else if (id.startsWith("PRB")) {
        return { ...baseData, source: "problem" } as unknown as ProblemData;
      } else {
        return { ...baseData, source: "incident" } as unknown as IncidentData;
      }
    });
  };

  useEffect(() => {
    if (id) {
      authFetch(`${config.apiBaseUrl}/api/incidents/${id}`)
        .then((res) => res.json())
        .then(async (data) => {
          setIncident(data);
          setOriginalIncident(data); // Store original data
          if (data.relatedobject) {
            const ticketIds = Array.isArray(data.relatedobject)
              ? data.relatedobject
              : data.relatedobject.split(",");
            const tasks = await mockLoadTasksByIds(ticketIds);
            setSelectedTask(tasks);
          }
        })
        .catch((err) => console.error("Failed to fetch incident:", err));
    }
  }, [id]);

  useEffect(() => {
    const { urgency, impact } = incident;
    if (!urgency || !impact) return;
    const key = `${urgency}-${impact}`;
    let priority = "";
    if (key === "Critical-Critical") priority = "Critical";
    else if (
      key === "Critical-High" ||
      key === "High-High" ||
      key === "High-Critical"
    )
      priority = "High";
    else if (
      key === "Critical-Medium" ||
      key === "High-Medium" ||
      key === "Medium-High" ||
      key === "Medium-Medium" ||
      key === "Medium-Critical"
    )
      priority = "Medium";
    else if (
      key === "Low-Low" ||
      key === "Low-High" ||
      key === "Low-Medium" ||
      key === "Low-Critical"
    )
      priority = "Low";
    else if (
      key === "Medium-Low" ||
      key === "High-Low" ||
      key === "Critical-Low"
    )
      priority = "Low";
    setIncident((prev) => ({ ...prev, priority }));
  }, [incident.urgency, incident.impact]);

  const durationToMinutes = (duration: string): string => {
    const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
    if (!match) return "0";
    const hours = parseInt(match[1] || "0", 10);
    const minutes = parseInt(match[2] || "0", 10);
    const totalMinutes = hours * 60 + minutes;
    return `${totalMinutes} min`;
  };

  useFetchFullName((fullName: string) => {
    setIncident((prev) => ({ ...prev, user: fullName }));
  });

  // ✅ Updated cancel handler - no reload
  const handleCancel = () => {
    const hasChanges =
      JSON.stringify(incident) !== JSON.stringify(originalIncident);

    if (hasChanges) {
      const confirmLeave = window.confirm(
        "You have unsaved changes. Are you sure you want to leave without saving?"
      );
      if (!confirmLeave) {
        return;
      }
    }

    navigate("/incident", { state: { incident } });
  };
  const formatDate = (dateStr: string): string => {
    if (!dateStr) return "";
    return dateStr.replace("T", " ").split(".")[0];
  };

  const fetchMessages = async () => {
    if (!incident.ticketId) return; // prevent calling if empty
    const res = await authFetch(
      `${config.apiBaseUrl}/api/messages/ticket/${incident.ticketId}`
    );
    if (res.ok) setJournalMessages(await res.json());
  };
  const handleDataChange = (field: keyof Incident, value: any) => {
    setIncident((prev) => ({ ...prev, [field]: value }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (
      incident.incidentStartDatetime &&
      incident.incidentCloseDatetime &&
      new Date(incident.incidentCloseDatetime) <
        new Date(incident.incidentStartDatetime)
    ) {
      alert(
        "Incident Close Date/Time cannot be earlier than Incident Start Date/Time."
      );
      return; // ❌ stop submit
    }

    const updatedIncident: Incident = {
      ...incident,
      affectedSite:
        localStorage.getItem("isAllSite") === "true"
          ? ["All Sites"]
          : incident.affectedSite,
      affectedLink:
        localStorage.getItem("isAllLink") === "true"
          ? ["All Links"]
          : incident.affectedLink,
      affectedNetwork:
        localStorage.getItem("isAllNetwork") === "true"
          ? ["All Networks"]
          : incident.affectedNetwork,
    };
    const IGNORED_FIELDS: (keyof Incident)[] = [
      // ids / system
      "userid",
      "email",
      "createdby",
      "foruserid",

      // computed / duplicated display fields
      "ticketCreation",
      "ticketClosure",
      "incidentStart",
      "incidentClose",

      // system timestamps (usually auto-managed)
      "ticketCreationDatetime",
      "ticketClosureDatetime",

      // SLA / timers (often auto-calculated)
      "sla",
      "slaStatus",
      "reactionPoint",
      "responseTimeToOpen",
      "responseTimeToClose",
      "acceptanceTime",
      "ola",
      "olaStatus",
      "acceptanceStatus",

      // attachments/paths (optional: remove if you want to log file changes)
      "filePath",
      "uploadPath",

      // internal text sections if you don’t want to log them
      "journalUpdate",
      "communication",

      // ids used for lookups
      "networkId",
      "siteId",
      "linkId",
      "assetId",
      "teamId",
      "personId",
    ];
    const IGNORED_RAW_KEYS = new Set<string>(["updateDate", "timeElapsed"]);
    const FIELD_LABELS: Partial<Record<keyof Incident, string>> = {
      summary: "Summary",
      description: "Description",
      solution: "Solution",
      impact: "Impact",
      urgency: "Urgency",
      priority: "Priority",
      status: "Status",
      category: "Category",
      errorType: "Error Type",
      closureCode: "Closure Code",
      affectedCustomer: "Customer",
      affectedNetwork: "Network",
      affectedSite: "Site",
      affectedLink: "Link",
      affectedAntenna: "Antenna",
      asset: "Assets",
      incidentStartDatetime: "Incident Start Date/Time",
      incidentCloseDatetime: "Incident Close Date/Time",
      customerComplaint: "Customer Complaint",
      customerInformed: "Customer Informed",
      relatedobject: "Related Object",
    };

    const normalizeValue = (v: any) => {
      if (v === undefined || v === null) return "";
      if (Array.isArray(v)) return [...v].sort().join(","); // order-independent
      if (typeof v === "object") return JSON.stringify(v);
      return String(v).trim();
    };
    const getChangedFields = (before: Incident, after: Incident): string[] => {
      const keys = Object.keys(after) as (keyof Incident)[];
      const changed: string[] = [];

      for (const k of keys) {
        // ignore known Incident keys
        if (IGNORED_FIELDS.includes(k)) continue;

        // ignore unknown/raw backend keys if they exist
        if (IGNORED_RAW_KEYS.has(String(k))) continue;

        const b = normalizeValue((before as any)[k]);
        const a = normalizeValue((after as any)[k]);

        if (b !== a) {
          changed.push(FIELD_LABELS[k] ?? String(k));
        }
      }

      return changed;
    };

    const authToken = localStorage.getItem("authToken");
    console.log(
      "updatedIncidentupdatedIncidentupdatedIncident",
      updatedIncident
    );
    fetch(`${config.apiBaseUrl}/api/incidents/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
      },
      body: JSON.stringify(updatedIncident),
    })
      .then(async (res) => {
        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(
            `Error ${res.status}: ${errorText || res.statusText}`
          );
        }
        return res.json(); // ✅ get updated incident
      })
      .then(async (updatedIncidentFromServer) => {
        const changedFields = getChangedFields(
          originalIncident,
          updatedIncidentFromServer
        );

        await handleEdit(
          updatedIncidentFromServer,
          navigate,
          fetchMessages,
          changedFields
        );

        // optional but recommended so future edits compare correctly
        setIncident(updatedIncidentFromServer);
        setOriginalIncident(updatedIncidentFromServer);

        navigate("/incident", {
          state: { updatedIncident: updatedIncidentFromServer },
        });
      })

      .catch((err) => {
        console.error("Failed to update incident:", err);
        alert(`Failed to update incident: ${err.message}`);
      });
  };

  useEffect(() => {
    setCustomer(incident.affectedCustomer);
  }, [incident.affectedCustomer]);

  return (
    <div className="incident-form">
      <form onSubmit={handleSubmit}>
        <section className="form-section">
          <h3>Incident Information</h3>
          <div className="grid">
            <Input
              type="text"
              readOnly
              label="Created By"
              value={incident.createdby || ""}
              onChange={(val) => handleDataChange("createdby", val)}
            />
            {!isAdmin && (
              <ApiDropdown
                api={`users/by-organization/${organization}`}
                labelKey="username"
                valueKey="id"
                value={incident.userid || ""}
                label="User"
                onChange={async (val) => {
                  handleDataChange("userid", val);
                  try {
                    const res = await authFetch(
                      `${config.apiBaseUrl}/api/users/${val}`
                    );
                    if (!res.ok) throw new Error("User not found");
                    const user = await res.json();
                    handleDataChange("email", user.email);
                  } catch (err) {
                    console.error("Error fetching user:", err);
                  }
                }}
              />
            )}

            {isAdmin && (
              <ApiDropdown
                api="users"
                labelKey="username"
                valueKey="id"
                label="User"
                value={incident.userid || ""}
                onChange={async (val) => {
                  handleDataChange("userid", val);
                  if (val != null) {
                    try {
                      const res = await authFetch(
                        `${config.apiBaseUrl}/api/users/${val}`
                      );
                      if (!res.ok) throw new Error("User not found");
                      const user = await res.json();
                      handleDataChange("email", user.email);
                    } catch (err) {
                      console.error("Error fetching user:", err);
                    }
                  }
                }}
              />
            )}
            <Input
              type="text"
              readOnly
              label="Ticket Id"
              value={incident.ticketId || ""}
              onChange={(val) => handleDataChange("ticketId", val)}
            />
            <Input
              readOnly
              type="text"
              label="Status"
              value={incident.status || ""}
              onChange={(val) => handleDataChange("status", val)}
            />
            <Input
              type="datetime-local"
              readOnly
              label="Ticket Creation Date/Time"
              value={incident.ticketCreationDatetime}
              onChange={(val) =>
                handleDataChange("ticketCreationDatetime", val)
              }
            />
            <Input
              type="datetime-local"
              label="Ticket Closure Date/Time"
              readOnly
              value={incident.ticketClosureDatetime || ""}
              onChange={(val) => handleDataChange("ticketClosureDatetime", val)}
            />
            <Input
              type="datetime-local"
              label="Incident Start Date/Time (UTC)"
              value={incident.incidentStartDatetime || ""}
              onChange={(val) => handleDataChange("incidentStartDatetime", val)}
            />
            <Input
              type="datetime-local"
              label="Incident Close Date/Time (UTC)"
              value={incident.incidentCloseDatetime || ""}
              onChange={(val) => handleDataChange("incidentCloseDatetime", val)}
            />
            {isAdmin && (
              <Input
                type="text"
                label="Incident Cross Reference Number"
                value={incident.incidentCrossReference || ""}
                onChange={(val) =>
                  handleDataChange("incidentCrossReference", val)
                }
              />
            )}
            {isAdmin && (
              <>
                <Checkbox
                  label="Customer Complaint"
                  checked={incident.customerComplaint || false}
                  onChange={(e) =>
                    handleDataChange("customerComplaint", e.target.checked)
                  }
                />
                <Checkbox
                  label="Customer Informed"
                  checked={incident.customerInformed || false}
                  onChange={(e) =>
                    handleDataChange("customerInformed", e.target.checked)
                  }
                />
              </>
            )}
          </div>
        </section>

        <section className="form-section">
          <h3>Customer & Network</h3>
          <div className="grid">
            {!isAdmin && (
              <ApiDropdown
                api="affected-customers"
                labelKey="customername"
                value={organization}
                valueKey="customername"
                label="Customer"
                disabled
                isMulti
                onOpen={async () => {
                  try {
                    const responseIds = await authFetch(
                      `${config.apiBaseUrl}/api/users/id-by-organization?organization=${organization}`
                    );
                    if (!responseIds.ok)
                      throw new Error(
                        `HTTP error! status: ${responseIds.status}`
                      );
                    const userIds = await responseIds.json();
                    const userIdsParam = Array.isArray(userIds)
                      ? userIds.join(",")
                      : userIds;
                    const responseEmails = await authFetch(
                      `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                    );
                    if (!responseEmails.ok)
                      throw new Error(
                        `HTTP error! status: ${responseEmails.status}`
                      );
                    const emails = await responseEmails.json();
                    setEmails(emails);
                    handleDataChange("foruserid", userIds);
                    handleDataChange("affectedCustomer", [organization]);
                  } catch (error) {
                    console.error("Failed to fetch customer or emails:", error);
                  }
                }}
              />
            )}
              {isAdmin && !isForTelebras && !isForPetrobras && !isForNilesat && (
              <ApiDropdown
                api="affected-customers"
                labelKey="customername"
                required={true}
                valueKey="customername"
                label="Customer"
                isMulti
                value={incident.affectedCustomer}
                onChange={async (val) => {
                  setCustomer(val);
                  //console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", val);
                  handleDataChange("affectedCustomer", val);
                  try {
                    const responseIds = await authFetch(
                      `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`,
                    );
                    if (!responseIds.ok)
                      throw new Error(
                        `HTTP error! status: ${responseIds.status}`,
                      );
                    const userIds = await responseIds.json();
                    //console.log("Fetched user IDs:", userIds);

                    const userIdsParam = Array.isArray(userIds)
                      ? userIds.join(",")
                      : userIds;
                    const responseEmails = await authFetch(
                      `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`,
                    );
                    if (!responseEmails.ok)
                      throw new Error(
                        `HTTP error! status: ${responseEmails.status}`,
                      );
                    const emails = await responseEmails.json();
                    setEmails(emails);
                    //console.log("Fetched emails:", emails);

                    handleDataChange("foruserid", userIds);
                  } catch (error) {
                    console.error("Failed to fetch customer or emails:", error);
                  }
                }}
              />
            )}
            {isAdmin && isForTelebras && (
              <ApiDropdown
                api="affected-customers"
                labelKey="customername"
                required={true}
                valueKey="customername"
                label="Customer"
                isMulti
                disabled
                value={incident.affectedCustomer}
                onChange={async (val) => {
                  setCustomer(val);
                  //console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", val);
                  handleDataChange("affectedCustomer", val);
                  try {
                    const responseIds = await authFetch(
                      `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`,
                    );
                    if (!responseIds.ok)
                      throw new Error(
                        `HTTP error! status: ${responseIds.status}`,
                      );
                    const userIds = await responseIds.json();
                    //console.log("Fetched user IDs:", userIds);

                    const userIdsParam = Array.isArray(userIds)
                      ? userIds.join(",")
                      : userIds;
                    const responseEmails = await authFetch(
                      `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`,
                    );
                    if (!responseEmails.ok)
                      throw new Error(
                        `HTTP error! status: ${responseEmails.status}`,
                      );
                    const emails = await responseEmails.json();
                    setEmails(emails);
                    //console.log("Fetched emails:", emails);

                    handleDataChange("foruserid", userIds);
                  } catch (error) {
                    console.error("Failed to fetch customer or emails:", error);
                  }
                }}
              />
            )}
  {isAdmin && isForNilesat && (
              <ApiDropdown
                api="affected-customers"
                labelKey="customername"
                required={true}
                valueKey="customername"
                label="Customer"
                isMulti
                disabled
                value={incident.affectedCustomer}
                onChange={async (val) => {
                  setCustomer(val);
                  handleDataChange("affectedCustomer", val);
                  try {
                    const responseIds = await authFetch(
                      `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`,
                    );
                    if (!responseIds.ok)
                      throw new Error(
                        `HTTP error! status: ${responseIds.status}`,
                      );
                    const userIds = await responseIds.json();

                    const userIdsParam = Array.isArray(userIds)
                      ? userIds.join(",")
                      : userIds;
                    const responseEmails = await authFetch(
                      `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`,
                    );
                    if (!responseEmails.ok)
                      throw new Error(
                        `HTTP error! status: ${responseEmails.status}`,
                      );
                    const emails = await responseEmails.json();
                    setEmails(emails);

                    handleDataChange("foruserid", userIds);
                  } catch (error) {
                    console.error("Failed to fetch customer or emails:", error);
                  }
                }}
              />
            )}
  {isAdmin && isForPetrobras && (
              <ApiDropdown
                api="affected-customers"
                labelKey="customername"
                required={true}
                valueKey="customername"
                label="Customer"
                isMulti
                disabled
                value={incident.affectedCustomer}
                onChange={async (val) => {
                  setCustomer(val);
                  //console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", val);
                  handleDataChange("affectedCustomer", val);
                  try {
                    const responseIds = await authFetch(
                      `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`,
                    );
                    if (!responseIds.ok)
                      throw new Error(
                        `HTTP error! status: ${responseIds.status}`,
                      );
                    const userIds = await responseIds.json();
                    //console.log("Fetched user IDs:", userIds);

                    const userIdsParam = Array.isArray(userIds)
                      ? userIds.join(",")
                      : userIds;
                    const responseEmails = await authFetch(
                      `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`,
                    );
                    if (!responseEmails.ok)
                      throw new Error(
                        `HTTP error! status: ${responseEmails.status}`,
                      );
                    const emails = await responseEmails.json();
                    setEmails(emails);
                    //console.log("Fetched emails:", emails);

                    handleDataChange("foruserid", userIds);
                  } catch (error) {
                    console.error("Failed to fetch customer or emails:", error);
                  }
                }}
              />
            )}
            {!isAdmin && organization && (
              <ApiDropdown
                api={`everything/networks?customer=${organization}`}
                labelKey="label"
                valueKey="value"
                label="Networks"
                value={incident.affectedNetwork}
                isMulti
                onChange={(val) => {
                  setNetwork(val);
                  handleDataChange("affectedNetwork", val);
                }}
              />
            )}
            {!isAdmin && organization && (
              <>
                {(network || incident.affectedNetwork) && (
                  <ApiDropdown
                    api={`everything/sites?customer=${organization}&network=${
                      network || incident.affectedNetwork
                    }`}
                    labelKey="label"
                    valueKey="value"
                    label="Site"
                    value={incident.affectedSite}
                    isMulti
                    onChange={(val) => {
                      setSite(val);
                      handleDataChange("affectedSite", val);
                    }}
                  />
                )}
                {(site || incident.affectedSite) && (
                  <ApiDropdown
                    api={`everything/links?customer=${organization}&network=${
                      network || incident.affectedNetwork
                    }&site=${site || incident.affectedSite}`}
                    labelKey="label"
                    valueKey="value"
                    label="Link"
                    value={incident.affectedLink}
                    isMulti
                    onChange={(val) => handleDataChange("affectedLink", val)}
                  />
                )}
                <ApiDropdown
                  api={`everything/asset?customer=${organization}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label="Assets"
  value={incident.asset}
                  onChange={(val) => handleDataChange("asset", val)}
                />
<ApiDropdown
                  api={`everything/antenna?customer=${customer}`}
                  labelKey="label"
                  valueKey="value"
                  label="Antennas"
                  isMulti
                  value={incident.affectedAntenna}
                  onChange={(val) => {
                    handleDataChange("affectedAntenna", val);
                  }}
                />
              </>
            )}
            {isAdmin && (
              <>
                {(customer || incident.affectedCustomer) && (
                  <ApiDropdown
                    api={`everything/networks?customer=${
                      customer || incident.affectedCustomer
                    }`}
                    labelKey="label"
                    valueKey="value"
                    label="Networks"
                    value={incident.affectedNetwork}
                    isMulti
                    onChange={(val) => {
                      setNetwork(val);
                      handleDataChange("affectedNetwork", val);
                    }}
                  />
                )}
                {(network || incident.affectedNetwork) && (
                  <ApiDropdown
                    api={`everything/sites?customer=${
                      customer || incident.affectedCustomer
                    }&network=${network || incident.affectedNetwork}`}
                    labelKey="label"
                    valueKey="value"
                    value={incident.affectedSite || ""}
                    label="Site"
                    isMulti
                    onChange={(val) => {
                      setSite(val);
                      handleDataChange("affectedSite", val);
                    }}
                  />
                )}
                {(site || incident.affectedSite) && (
                  <ApiDropdown
                    api={`everything/links?customer=${
                      customer || incident.affectedCustomer
                    }&network=${network || incident.affectedNetwork}&site=${
                      site || incident.affectedSite
                    }`}
                    labelKey="label"
                    valueKey="value"
                    label="Link"
                    value={incident.affectedLink}
                    isMulti
                    onChange={(val) => handleDataChange("affectedLink", val)}
                  />
                )}
                <ApiDropdown
                  api={`everything/asset?customer=${customer}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label="Assets"
       value={incident.asset}
                  onChange={(val) => handleDataChange("asset", val)}
                />
<ApiDropdown
                  api={`everything/antenna?customer=${customer}`}
                  labelKey="label"
                  valueKey="value"
                  label="Antennas"
                  isMulti
                  value={incident.affectedAntenna}
                  onChange={(val) => {
                    handleDataChange("affectedAntenna", val);
                  }}
                />
              </>
            )}
          </div>
        </section>

        <section className="form-section">
          <h3>Incident Severity</h3>
          <div className="grid">
            {isAdmin && (
              <ApiDropdown
                api="Impacts"
                labelKey="name"
                valueKey="name"
                label="Impact"
                value={incident.impact}
                onChange={(val) => handleDataChange("impact", val)}
              />
            )}
            <ApiDropdown
              api="Urgencys"
              labelKey="name"
              valueKey="name"
              label="Urgency"
              value={incident.urgency}
              onChange={(val) => handleDataChange("urgency", val)}
            />
            {isAdmin && (
              <Input
                readOnly
                type="text"
                label="Priority"
                value={incident.priority || ""}
                onChange={(val) => handleDataChange("priority", val)}
              />
            )}
          </div>
        </section>

        <section className="form-section">
          <h3>Incident Details</h3>
          <div className="grid2">
            <TextArea
              label="Summary"
              value={incident.summary || ""}
              onChange={(val) => handleDataChange("summary", val)}
              style={{
                minHeight: "30px",
                minWidth: "90%",
                backgroundColor: "white",
              }}
            />
            <TextArea
              label="Description"
              value={incident.description || ""}
              onChange={(val) => handleDataChange("description", val)}
              style={{
                minHeight: "100px",
                minWidth: "90%",
                backgroundColor: "white",
              }}
            />
            <TextArea
              label="Solution"
              value={incident.solution || ""}
              style={{
                minHeight: "100px",
                minWidth: "90%",
                backgroundColor: "white",
              }}
              onChange={(val) => handleDataChange("solution", val)}
            />
            <ApiDropdown
              api="ClosureCodes"
              labelKey="name"
              valueKey="name"
              label="Closure Code"
              value={incident.closureCode}
              onChange={(val) => handleDataChange("closureCode", val)}
            />
            <ApiDropdown
              api="Errors"
              labelKey="type"
              valueKey="type"
              label="Error Type"
              value={incident.errorType}
              onChange={(val) => handleDataChange("errorType", val)}
            />

            <ApiDropdown
              api="categories"
              required
              labelKey="name"
              valueKey="name"
              label="Category"
              value={incident.category}
              onChange={(val) => handleDataChange("category", val)}
            />
          </div>
        </section>

        {isAdmin && (
          <section className="form-section">
            <h3>Responsibility</h3>
            <div className="grid">
              <>
                <Input
                  readOnly
                  type="text"
                  label="Responsible Team"
                  value={incident.responsibleTeam || ""}
                  onChange={() => {}}
                />
                <Input
                  readOnly
                  type="text"
                  label="Responsible Person"
                  value={incident.responsiblePerson || ""}
                  onChange={() => {}}
                />
              </>
            </div>
          </section>
        )}

        {isAdmin && (
          <section className="form-section">
            <h3>SLA & OLA</h3>
            <div className="grid">
              <Input
                readOnly
                type="text"
                label="SLA "
                value={incident.sla || ""}
                onChange={(val) => handleDataChange("sla", val)}
              />
              <Input
                readOnly
                type="text"
                label="SLA Status"
                value={incident.slaStatus || ""}
                onChange={(val) => handleDataChange("slaStatus", val)}
              />
              <Input
                readOnly
                type="text"
                label="Reaction Point"
                value={
                  incident.reactionPoint
                    ? formatDate(incident.reactionPoint)
                    : ""
                }
                onChange={(val) => handleDataChange("reactionPoint", val)}
              />
              <Input
                readOnly
                type="text"
                value={durationToMinutes(incident.responseTimeToOpen || "")}
                label="Response Time To Open"
                onChange={(val) => handleDataChange("responseTimeToOpen", val)}
              />
              <Input
                readOnly
                type="time"
                label="Response Time To Close"
                value={durationToMinutes(incident.responseTimeToClose || "")}
                onChange={(val) => handleDataChange("responseTimeToClose", val)}
              />
              <Input
                type="datetime-local"
                label="Acceptance Time"
                readOnly
                value={
                  incident.acceptanceTime
                    ? formatDateTimeLocal(incident.acceptanceTime)
                    : ""
                }
                onChange={(val) => handleDataChange("acceptanceTime", val)}
              />
              <Input
                readOnly
                type="text"
                label="Acceptance Status"
                value={incident.acceptanceStatus || ""}
                onChange={(val) => handleDataChange("acceptanceStatus", val)}
              />
              <Input
                readOnly
                type="text"
                label="OLA"
                value={incident.ola || ""}
                onChange={(val) => handleDataChange("ola", val)}
              />
              <Input
                readOnly
                type="text"
                label="OLA Status"
                value={incident.olaStatus || ""}
                onChange={(val) => handleDataChange("olaStatus", val)}
              />
            </div>
          </section>
        )}

        <section className="form-section">
          <h3>Related Object</h3>
          <div className="grid">
            <FileUploader
              value={incident.filePath}
              onRemove={(path) =>
                handleDataChange("filePath", (incident.filePath || []).filter((p: any) => p !== path))
              }
              onChange={async (files, paths) => {
                if (!files || !paths.length) return;
                const uploadedPaths: string[] = [];
                for (let i = 0; i < files.length; i++) {
                  const formData = new FormData();
                  formData.append("file", files[i]);
                  try {
                    const response = await authFetch(
                      `${config.apiBaseUrl}/api/incidents/upload`,
                      {
                        method: "POST",
                        body: formData,
                      }
                    );
                    if (response.ok) {
                      const { path } = await response.json();
                      uploadedPaths.push(path);
                    } else {
                      console.error(`Upload failed for file: ${files[i].name}`);
                    }
                  } catch (error) {
                    console.error("Error uploading file", error);
                  }
                }
                if (uploadedPaths.length) {
                  handleDataChange("filePath", [
                    ...(incident.filePath || []),
                    ...uploadedPaths,
                  ]);
                }
              }}
            />
            {isAdmin && (
              <Input
                readOnly
                type="text"
                label="Related Object"
                value={incident.relatedobject || ""}
                onChange={(val) => handleDataChange("relatedobject", val)}
              />
            )}
            <>
              {isAdmin && !isForTelebras  && !isForNilesat &&(
                <button type="button" onClick={handleOpenTaskLookup}>
                  Select Related Ticket
                </button>
              )}
              {selectedTask && selectedTask.length > 0 && (
                <div>
                  <p>
                    <strong>Selected Tasks:</strong>
                  </p>
                  <ul>
                    {selectedTask.map((task, index) => (
                      <li key={index}>{task.ticketId}</li>
                    ))}
                  </ul>
                </div>
              )}
              <TaskGridLookup
                isOpen={isTaskLookupOpen}
                onClose={handleCloseTaskLookup}
                selectedItems={toRelatedItems(incident.relatedobject)}

                onSelect={handleTaskSelect}
              />
            </>
          </div>
        </section>

        <div
          className="form-actions"
          style={{ display: "flex", gap: "10px", marginTop: "20px" }}
        >
          <button onClick={handleSubmit}>Submit Incident</button>

          <Button type="button" onClick={handleCancel} className="cancel-btn">
            Cancel
          </Button>
        </div>
      </form>
    </div>
  );
}

export default IncidentEdit;
